import volcanoImg from "../../../../images/contents/map/vaa/volcano.png";

export const configVaaDh = {
  "data": {
    "Type": "GeoJSON",
    "url": "%wrap_url%/WX_ALL_VAA/latest.json",
    "_url": "pri/data/vaa_multi_vaac.json",//複数VAACのダミーデータ
    "update_interval": 60,
    "retain": true,
    "cache": false,
    "cache_busting": true
  }
};

export const configVaaLayer = {
  "Name": "VAA",
  "Renderer": "GeoJSON",
  "Attributes": {
    "features": [
      {
        "selector": {
          "type": "key_value",
          "key": "color_type",
          "value": "latest_act"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "line_color": "#ff0000",
            "line_width": 2,
            "fill_color": "rgba(255,0,0,0.1)"
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "color_type",
          "value": "latest_6h"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "text_color": "#FF9A9D",
            "line_color": "#ffc0cb",
            "line_width": 2,
            "fill_color": "rgba(255,192,203,0.1)"
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "color_type",
          "value": "latest_12h"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "line_color": "#ffa500",
            "line_width": 2,
            "fill_color": "rgba(255,165,0,0.1)"
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "color_type",
          "value": "latest_18h"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "line_color": "#1e90ff",
            "line_width": 2,
            "fill_color": "rgba(30,144,255,0.1)"
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "color_type",
          "value": "old_act"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "line_width": 2,
            "fill_color": "rgba(255,0,0,0)"
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "color_type",
          "value": "old_6h"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "line_width": 2,
            "fill_color": "rgba(255,192,203,0)"
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "color_type",
          "value": "old_12h"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "line_width": 2,
            "fill_color": "rgba(255,165,0,0)"
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "color_type",
          "value": "old_18h"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "line_width": 2,
            "fill_color": "rgba(30,144,255,0)"
          }
        }
      },
      {
        "style": {
          "default": {
            "type": "image",
            "width": 32,
            "height": 32,
            "offset_x": -16,
            "offset_y": -16,
            "url": volcanoImg
          }
        }
      }
    ]
  }
};

export const configVaaAddingLayer = {
  "default": {
    "offsetY": -16,
    "alt": {
      "fontSize": 13,
      "align": "center"
    }
  }
};
